import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import React, { useState } from 'react';
import clsx from 'clsx';
import capitalize from "../../helpers/capitalize";
import { EyeSlash, Eye, Search } from "../../icons";
import { Button, Guideline } from "./..";
import ValidationBlock from "../ValidationBlock";

import { createStyles } from "./styles";

var InputText = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var
    value =
















    props.value,onChange = props.onChange,name = props.name,label = props.label,description = props.description,id = props.id,maxLength = props.maxLength,minLength = props.minLength,validationMessage = props.validationMessage,_props$validationPass = props.validationPassed,validationPassed = _props$validationPass === void 0 ? true : _props$validationPass,placeholder = props.placeholder,_props$inputType = props.inputType,inputType = _props$inputType === void 0 ? 'column' : _props$inputType,_props$disabled = props.disabled,disabled = _props$disabled === void 0 ? false : _props$disabled,className = props.className,_props$htmlType = props.htmlType,htmlType = _props$htmlType === void 0 ? 'text' : _props$htmlType,additionalOptions = props.additionalOptions,_props$currentDate = props.currentDate,currentDate = _props$currentDate === void 0 ? '' : _props$currentDate;
  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),showPassword = _useState2[0],setShowPassword = _useState2[1];
  var classes = createStyles(props);

  var changePasswordStatus = function changePasswordStatus() {
    setShowPassword(!showPassword);
  };

  var PasswordButton = function PasswordButton() {
    return showPassword ? /*#__PURE__*/
    React.createElement(Button, { type: "icon", className: classes.passwordButton, onClick: changePasswordStatus }, /*#__PURE__*/
    React.createElement(Eye, { width: "1.8rem", height: "1.8rem" })) : /*#__PURE__*/


    React.createElement(Button, { type: "icon", className: classes.passwordButton, onClick: changePasswordStatus }, /*#__PURE__*/
    React.createElement(EyeSlash, null));


  };

  return /*#__PURE__*/(
    React.createElement("div", {
      className: clsx(
      classes.wrapper,
      classes["wrapper".concat(capitalize(inputType))],
      className,
      classes.contributionBlock) },


    (label || description) && /*#__PURE__*/
    React.createElement("div", { className: classes.descriptionWrapper }, /*#__PURE__*/
    React.createElement("label", { htmlFor: name, className: clsx(classes.label) },
    label), /*#__PURE__*/

    React.createElement("p", { className: classes.description }, description)), /*#__PURE__*/


    React.createElement("div", { className: (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.contributionType) && classes.contributionWrapper }, /*#__PURE__*/
    React.createElement("div", { className: classes.fieldWrapper },
    htmlType === 'search' && /*#__PURE__*/React.createElement(Search, { className: classes.inlineIcon }),
    (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.contributionType) === 'percentage' && /*#__PURE__*/
    React.createElement("span", { className: classes.contributionSign }, "%"),

    (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.contributionType) === 'dollar' && /*#__PURE__*/
    React.createElement("span", { className: classes.contributionSign }, "$"),

    htmlType === 'password' && PasswordButton(), /*#__PURE__*/
    React.createElement("input", {
      type: htmlType === 'password' ? showPassword ? 'text' : 'password' : htmlType,
      value: value,
      onChange: onChange,
      name: name,
      id: id,
      maxLength: maxLength,
      minLength: minLength,
      className: clsx(
      classes.input,
      classes["inputValidation".concat(capitalize(validationPassed.toString()))],
      disabled && classes.inputDisabled,
      htmlType === 'search' && classes.searchInput,
      classes.contributionInput),

      placeholder: placeholder && placeholder,
      disabled: disabled,
      ref: ref,
      max: currentDate }), /*#__PURE__*/

    React.createElement(ValidationBlock, {
      value: value,
      validationMessage: validationMessage,
      validationPassed: validationPassed }),

    (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.guidelines) && /*#__PURE__*/
    React.createElement(Guideline, {
      text: additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.guidelines,
      showGuidelinesByDefault: additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.showGuidelinesByDefault,
      className: classes.inputGuideline })),



    (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.contributionType) === 'dollar' && /*#__PURE__*/
    React.createElement("span", { className: classes.contributionInterval },
    additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.contributionInterval))));





});
InputText.displayName = 'InputText';

export default InputText;
//# sourceMappingURL=index.js.map